import React, { useState } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import axiosInstance from "../../../../axiosinterceptor"; // adjust path to match your project

async function getReferencesWithPageNumber(content, s3Location) {
  const response = await axiosInstance.post("/ics_get_references_with_page_number", {
    content,
    s3Location,
  });
  return response.data;
}

const ReferenceModal = ({ citationlength, eachLocation, reference }) => {
  const [popoverResponse, setPopoverResponse] = useState({
    content: "",
    page_number: [],
    reference_documents: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showToolTip, setShowToolTip] = useState(false);

  const handleOutSideClick = (event) => {
    const sanitizedReferenceId = CSS.escape(`reference-${reference.source}`);
    if (
      !event.target.closest(`#${sanitizedReferenceId}`) &&
      !event.target.closest(".citations-button")
    ) {
      setShowToolTip(false);
      setPopoverResponse(null);
      document.removeEventListener("click", handleOutSideClick);
    }
  };

  const handleReferenceClick = async (e, reference) => {
    e.preventDefault();
    if (showToolTip) {
      setShowToolTip(false);
      setPopoverResponse(null);
      document.removeEventListener("click", handleOutSideClick);
      return;
    }
    const content = reference?.content ? reference?.content : reference.reference_text;
    const s3Location = reference.location ? reference?.location : reference?.source;
    setIsLoading(true);
    setShowToolTip(true);
    try {
      const result = await getReferencesWithPageNumber(content, s3Location);
      const popoverdata = result.pages[0];
      setPopoverResponse(popoverdata);
    } catch (error) {
      console.log("Error fetching references with page number:", error.message);
    } finally {
      setIsLoading(false);
      document.addEventListener("click", handleOutSideClick);
    }
  };

  const handleNoReferenceClick = (e) => {
    e.preventDefault();
    if (showToolTip) {
      setShowToolTip(false);
      setPopoverResponse(null);
      document.removeEventListener("click", handleOutSideClick);
      return;
    }
    setIsLoading(true);
    setShowToolTip(true);
    document.addEventListener("click", handleOutSideClick);
  };

  const pg_no = popoverResponse?.page_number?.join(", ");

  const handleDownloadBookClick = (fileName) => {
    setIsLoading(true);
    axiosInstance
      .get(`/lambda_genai_ics_v1/?file_name=${fileName}&pg_no=${pg_no}`)
      .then((response) => {
        const { url } = response.data;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <OverlayTrigger
      trigger="click"
      placement="right"
      show={showToolTip}
      overlay={
        <Popover id={`reference-${reference?.source}`}>
          <Popover.Body>
            <h6>Context</h6>
            <div className="ml-2">
              {reference?.content
                ? reference?.content
                    .replace(/^:\s*"/, '"')
                    .replace(/[\r\n]+/g, "")
                    .replace(/},\s*{/g, "},{")
                : reference?.reference_text}
            </div>
            <h6>References:</h6>
            {isLoading && !reference?.location ? (
              <h6 className="references-color">Loading ...</h6>
            ) : (
              <div className="references-color">
                {reference?.content ? (
                  eachLocation?.map((loc, index) => (
                    <p style={{ marginBottom: "5px" }} key={index}>
                      {"*" + loc.split("/").pop()}
                    </p>
                  ))
                ) : popoverResponse?.page_number?.length > 0 ? (
                  <p>{popoverResponse?.reference_documents.join(", ")}</p>
                ) : (
                  <p>References not Found</p>
                )}

                {reference?.content ? (
                  eachLocation && eachLocation.length > 0 ? (
                    eachLocation.some((location) =>
                      location?.split("/").pop()?.endsWith(".pdf"),
                    ) ? (
                      reference?.metadata && reference.metadata.length > 0 ? (
                        <p>Page Number: {reference.metadata}</p>
                      ) : (
                        " "
                      )
                    ) : (
                      " "
                    )
                  ) : (
                    " "
                  )
                ) : popoverResponse?.page_number?.length > 0 ? (
                  <p>Page Number: {popoverResponse?.page_number.join(", ")}</p>
                ) : (
                  <p>Page Number not Found</p>
                )}
              </div>
            )}
            <div
              className="hyperlink-v2"
              onClick={() => handleDownloadBookClick(reference?.source)}
            >
              {popoverResponse?.page_number?.length > 0 && (
                <a className="hyperlink-anchor-v2">{reference?.location}</a>
              )}
            </div>
          </Popover.Body>
        </Popover>
      }
    >
      {reference?.citation_number ? (
        <button
          className="citations-button"
          onClick={(e) => handleReferenceClick(e, reference)}
        >
          {reference?.citation_number}
        </button>
      ) : (
        <button
          className="citations-button"
          onClick={(e) => handleNoReferenceClick(e)}
        >
          {citationlength + 1}
        </button>
      )}
    </OverlayTrigger>
  );
};

export const GenerateCDQModal = ({ message }) => {
  return (
    <>
      {message?.answer ? (
        <>
          <div>
            <p>{message?.answer?.message}</p>
            {message?.answer?.references?.map((item, index) => (
              <ReferenceModal
                key={`item-${index}`}
                citationlength={index}
                eachLocation={message?.answer?.location}
                reference={item}
              />
            ))}
          </div>

          {Object.keys(message.answer).map((key) => {
            const msz = message.answer[key];
            if (key.startsWith("answer_chunk")) {
              return (
                <div key={key}>
                  {msz?.answer}
                  {msz?.references?.map((reference, i) => (
                    <ReferenceModal key={i} citationlength={i} reference={reference} />
                  ))}
                </div>
              );
            }
            return null;
          })}
        </>
      ) : null}
    </>
  );
};